export interface IntegrationDefinitionVm {
  id: string;
  image: string;
  landingPageUrl: string;
  helpUrl: string;
  name: string;
  removeBehaviour?: RemoveBehaviour;
  videoExplainer?: string;
}

export enum RemoveBehaviour {
  Portal = 0,
  External = 1
}
